/**
 * DataService.js
 * 
 * Ce service centralise les appels de données. 
 * Pour passer au Cloud (PocketBase, Firebase, SQL), 
 * il suffit de remplacer les appels localStorage par des appels fetch/sdk.
 */

const STORAGE_KEY = 'sugarhut_data';

export const DataService = {
    // Récupérer toutes les données (Menu, Vouchers, Loyalty, etc.)
    async getAllData(initialData) {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved) {
            try {
                return JSON.parse(saved);
            } catch (e) {
                console.error("Parse error", e);
                return initialData;
            }
        }
        return initialData;
    },

    // Sauvegarder les données
    async saveData(newData) {
        // En mode Cloud, on ferait un POST/PUT ici
        localStorage.setItem(STORAGE_KEY, JSON.stringify(newData));
        // Déclencher un événement pour synchroniser les autres onglets
        window.dispatchEvent(new StorageEvent('storage', {
            key: STORAGE_KEY,
            newValue: JSON.stringify(newData)
        }));
        return { success: true };
    },

    // Gestion des points (Client)
    getUserPoints() {
        return parseInt(localStorage.getItem('sugarhut_points') || '0');
    },

    saveUserPoints(points) {
        localStorage.setItem('sugarhut_points', points.toString());
    }
};
